export default __webpack_public_path__ + "static/media/k.d138b8ad.jfif";